<template>
  <div class="web-new-coupon__home__container">
    <router-view />
  </div>
</template>

<script>
// import { BsUtil, BsGetCid } from 'dida-web-common'
export default {
  data() {
    return {
      homeList: {}
    }
  },
  inject: ['predictData', 'closeLoading'],
  computed: {
    homeData() {
      return this.predictData()
    }
  },
  watch: {
    homeData: {
      handler(val) {
        console.log('home ==========》页面得到的predictData', val)
        if (Object.keys(val).length > 0) {
          // this.homeList = val
          this.statusOprate(val)
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    // console.log(2222222)
    this.$nextTick(() => {
      this.closeLoading()
    })
  },
  created() {
    // this.$nextTick(() => {
    //   if (Object.keys(this.homeList).length > 0) {
    //       this.statusOprate(this.homeList)
    //   }
    // })
  },
  methods: {
    statusOprate(val) {
      // 根据数据状态展示相应的路由
      if (val.code === 0) {
        if (val.data.isAward) {
          this.$router.replace({
            path: `/couponList${window.location.search}`
          })
        } else {
          this.$router.replace({
            path: `/group${window.location.search}`
          })
        }
      } else {
        this.$router.replace({
          path: `/errTip${window.location.search}`
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
